'use strict';

angular.module('user').controller('UserProfileDataFormController', [
    '$q',
    'AccountManager',
    'ShareCrfApiErrorCodes',
    'ShareCrfLanguageService',
    'ShareCrfCountries',
    function(
        $q,
        AccountManager,
        ShareCrfApiErrorCodes,
        ShareCrfLanguageService,
        ShareCrfCountries
    ) {
        var vm = this;
        var editableFields = [
            'company',
            'country',
            'language',
            'lastname',
            'name',
            'newsletter',
        ];

        vm.ready = false;
        vm.countriesOptions = ShareCrfCountries.getOptions(true);

        vm.$onInit = function() {
            return AccountManager.init()
                .then(function() {
                    vm.data = _.clone(AccountManager.getLoggedUser());

                    vm.submitted = false;
                    vm.running = false;

                    vm.error = false;
                    vm.success = false;

                    vm.ready = true;

                    /**
                     * Submit form
                     *
                     * @param {Form}
                     *
                     * @return {Promise}
                     */
                    vm.submit = function(form) {
                        vm.submitted = true;
                        vm.error = false;
                        vm.success = false;

                        var promise = $q.resolve();

                        if (form.$valid) {
                            vm.running = true;

                            var data = _.pick(vm.data, editableFields);

                            promise = AccountManager.updateProfile(data)
                                .then(function(res) {
                                    var locale = data.language + '_' + data.country;
                                    ShareCrfLanguageService.setLanguage(data.language, locale);
                                    vm.countriesOptions = ShareCrfCountries.getOptions(true);
                                    vm.running = false;
                                    vm.success = true;
                                })
                                .catch(function(error) {
                                    vm.running = false;
                                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                                });
                        }

                        return promise;
                    };
                });
        };
    },
]);
